const HPNotificationPriority =
{
    Mandatory: 1,
    Optional: 2,
};

export default HPNotificationPriority;




// WEBPACK FOOTER //
// ./src/app/config/constants/NotificationPriorityTypes.constant.js